export enum UserCookLeaveLinkDisputeResolution {
    RESOLVED = "RESOLVED",
    REJECTED = "REJECTED"
}